import IncomeAssetsStep from './IncomeAssetsStep'

export default IncomeAssetsStep
